"use client";

import { Link } from "@/i18n/routing";
import { GoogleSignInIcon, IconLogin, IconLoginWithOTP } from "@repo/assets/images";
import { LoginForm, OtpWrapper, RegisterForm } from "@repo/components";
import { useSnackbarContext } from "@repo/contexts/SnackbarContext";
import { useAuth } from "@repo/lib/hooks/account";
import { Button, LoadingDots } from "@repo/ui";
import cx from "classnames";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
import { useCallback, useEffect, useState } from "react";
const LoginWrapper = ({
  variant,
  handleCheckoutSignIn
}) => {
  const [showOTPForm, setShowOTPForm] = useState(false);
  const [showVerifyOTP, setShowVerifyOTP] = useState(false);
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const tLogin = useTranslations("LoginPage");
  const tCommon = useTranslations("Common");
  const tAccount = useTranslations("Account");
  const {
    handleSocialSubmit,
    isSocialLoginPending
  } = useAuth({
    variant,
    handleCheckoutSignIn
  });
  const isGoogleLoginAvailable = process.env.NEXT_PUBLIC_IS_SOCIAL_LOGIN_AVAILABLE ?? false;
  const handleLoginForms = useCallback(() => {
    setShowOTPForm(!showOTPForm);
  }, [showOTPForm]);
  const handleShowRegister = useCallback(() => {
    setShowRegisterForm(true);
    setShowOTPForm(false);
  }, []);
  const handleBackToLogin = useCallback(() => {
    setShowRegisterForm(false);
  }, []);
  const searchParams = useSearchParams();
  const {
    setSnackbar
  } = useSnackbarContext();
  useEffect(() => {
    const error = searchParams.get("error");
    const message = searchParams.get("message");
    if (error === "social" && message) {
      setSnackbar({
        open: true,
        message: decodeURIComponent(message),
        type: "error"
      });
    }
  }, [searchParams, setSnackbar]);
  return <>
      <div className={cx("mx-auto", {
      "max-w-sm py-[72px]": variant !== "secondary"
    })}>
        {!showRegisterForm && !showOTPForm && <LoginForm variant={variant} handleCheckoutSignIn={handleCheckoutSignIn} />}
        {!showRegisterForm && showOTPForm && <OtpWrapper showVerifyOTP={showVerifyOTP} setShowVerifyOTP={setShowVerifyOTP} variant={variant} handleCheckoutSignIn={handleCheckoutSignIn} />}
        {showRegisterForm && <RegisterForm variant={variant} handleCheckoutSignIn={handleCheckoutSignIn} />}
        {!showVerifyOTP && !showRegisterForm && <>
            <div className={cx("my-4", {
          "flex flex-col gap-3 md:flex-row": isGoogleLoginAvailable
        })}>
              {isGoogleLoginAvailable && <Button type="button" size="md" className="w-full md:!px-2.5" variant="secondary" onClick={() => handleSocialSubmit("google")}>
                  {isSocialLoginPending ? <LoadingDots className="bg-gray-800" /> : <span className="inline-flex items-center gap-2 whitespace-nowrap">
                      <GoogleSignInIcon className="" />
                      {tCommon("Login_With_Google")}
                    </span>}
                </Button>}
              <Button size="md" type="button" className="w-full md:!px-2.5" variant="secondary" onClick={handleLoginForms}>
                {!showOTPForm ? <span className="inline-flex items-center gap-2 whitespace-nowrap">
                    <IconLoginWithOTP />
                    {tLogin("Login_With_OTP")}
                  </span> : <span className="inline-flex items-center gap-2 whitespace-nowrap">
                    <IconLogin />
                    {tLogin("Login_With_Password")}
                  </span>}
              </Button>
            </div>

            <>
              <p className="border-supportiveDarkGray border-t py-3 text-center font-medium">
                {tLogin("Dont_Have_An_Account")}{" "}
                {variant === "secondary" ? <button type="button" className="text-anchor-text hover:text-anchor-hover hover:underline" onClick={handleShowRegister}>
                    {tCommon("Register")}
                  </button> : <Link href="/register" className="text-anchor-text hover:text-anchor-hover hover:underline">
                    {tCommon("Register")}
                  </Link>}
              </p>
            </>
          </>}
        {variant === "secondary" && showRegisterForm && <p className="border-supportiveDarkGray border-t py-3 text-center font-medium">
            {tAccount("Already_Have_An_Account")}{" "}
            <button type="button" className="text-anchor-text hover:text-anchor-hover hover:underline" onClick={handleBackToLogin}>
              {tCommon("Login")}
            </button>
          </p>}
      </div>
    </>;
};
export default LoginWrapper;